// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"78cde94c","111":"78cde94c","128":"78cde94c","261":"78cde94c","404":"78cde94c","518":"78cde94c","611":"78cde94c","779":"78cde94c","874":"78cde94c","936":"78cde94c","985":"78cde94c"}[chunkId] + ".chunk.css";
};